import { render, staticRenderFns } from "./CardAverbacao.vue?vue&type=template&id=d7630932&scoped=true&"
import script from "./CardAverbacao.vue?vue&type=script&lang=js&"
export * from "./CardAverbacao.vue?vue&type=script&lang=js&"
import style0 from "./CardAverbacao.vue?vue&type=style&index=0&id=d7630932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7630932",
  null
  
)

export default component.exports